import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const TopStudentsList = () => {
  const topStudents = [
    { name: 'John Doe', score: 98 },
    { name: 'Jane Smith', score: 95 },
    { name: 'Michael Brown', score: 92 },
  ];

  return (
    <ListGroup>
      {topStudents.map((student, index) => (
        <ListGroupItem key={index}>
          {student.name} - Score: {student.score}%
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

export default TopStudentsList;
